import Veraportal from "./Veraportal";
import Utilities from "./Utilities";

export interface IModalOptions {
    id?: string,
    title?: string,
    body?: string,
    hasSubmit?: boolean,
    hasBestaetigung?: boolean,
    hasCancel?: boolean,
    cancelText?: string,
    submitText?: string,
    width?: number,
    initFunction?: Function,
    validationFunction?: Function,
    einmalpopupCookieId?: string | null
}

export default class Modal {
    protected _veraportal: Veraportal;
    protected modalId: string;
    protected modalOptions: IModalOptions;
    protected headHTML: string;
    protected mainHTML: string;
    protected footerHTML: string;

    public constructor(veraportal: Veraportal) {
        this._veraportal = veraportal;
    }

    /*
    Vorher initialisiertes Modalfenster anzeigen. Dabei muss ein modalOptions-Objekt übergeben werden.
     */
    /**
     *  Eigenschaften des Popups müssen hier mit übergeben werden.<br/>
     *  id?: id, welche in der DOM für das Modalfenster gesetzt wird. Falls leer, wird eine zufällig generiert.<br/>
     *  title?: Text in der Headerzeile<br/>
     *  body: HTML das im Hauptbereich des Modalfensters angezeigt werden soll<br/>
     *  hasSubmit?: Kann der Nutzer 'Ja' drücken?<br/>
     *  hasBestaetigung?: Muss der Nutzer vorher 'OK' eingeben?<br/>
     *  hasCancel?: Kann der Nutzer auch 'Abbrechen' drücken?<br/>
     *  cancelText?: Abbrechen-Button-Text<br/>
     *  submitText?: Submit-Button-Text<br/>
     *  initFunction?: Es kann eine Funktion übergeben werden, die nach dem Einhängen des Modals in die DOM feuert.<br/>
     *  validationFunction?: Wenn übergeben, prüft diese Funktion Werte beim Betätigen des Submit-Buttons.
     *  einmalpopupCookieId?: Wenn hier ein string hinterlegt ist, wird das Popup nur einmalig angezeigt und ein Cookie gespeichert
     **/
    public show(modalOptions: IModalOptions): Promise<boolean> {
        this.modalOptions = modalOptions;

        // early return: Modal nicht einblenden, wenn Cookie bereits gesetzt wurde
        if ((this.modalOptions.einmalpopupCookieId ?? null) !== null) {
            if ((Utilities.getCookie(`modal_seen_${this.modalOptions.einmalpopupCookieId}`) ?? '0') === '1')
                return this.antwortHandler(new Promise(() => true));
        }

        this.modalHead();
        this.modalMain();
        let antwortPromise = this.modalFooter();

        // Cookie speichern, weil Popup gesehen wurde
        if ((this.modalOptions.einmalpopupCookieId ?? null) !== null) {
            Utilities.setCookie(`modal_seen_${this.modalOptions.einmalpopupCookieId}`, '1', 60 * 24 * 300);
        }

        return this.antwortHandler(antwortPromise);
    }

    protected modalHead(): void {
        if (typeof this.modalOptions.id === 'undefined') {
            this.modalId = 'modal-generic' + Math.round(Math.random() * 1000).toString();
        } else {
            this.modalId = this.modalOptions.id;
        }

        this.headHTML = `
        <dialog id='${this.modalId}'>
          <article ${(this.modalOptions.width !== undefined) ? `style='width: ${this.modalOptions.width}px'` : ``}>
            <header>
            ${((this.modalOptions.title !== undefined) ? '<h3>' + this.modalOptions.title + '</h3>' : '')}
            ${(this.modalOptions.hasCancel === true || this.modalOptions.hasCancel === undefined) ? `
            <button role='button' class='close'>
                <svg role='graphics-symbol'>
                    <use href='/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#x'/>
                </svg>
            </button>
            ` : ``}
            </header>`;
    }

    protected modalMain(): void {
        this.mainHTML = `<main>${this.modalOptions.body ?? ''}</main>`;
    }

    protected modalFooter(): Promise<any> {
        return new Promise(async (resolve) => {
            this.footerHTML = `
            ${(this.modalOptions.hasSubmit === true || this.modalOptions.hasCancel === true) ? `
            <footer>
              ${(this.modalOptions.hasBestaetigung === true) ? `<div class='bestaetigung'>Bestätigung: <input type='text' id='${this.modalId}-bestaetigung' autocomplete='off'/></div>` : ``}
              ${(this.modalOptions.hasCancel === true || this.modalOptions.hasCancel === undefined) ? `<button role='button' class='close' data-target='${this.modalId}'>${(this.modalOptions.cancelText === undefined) ? 'Abbrechen' : this.modalOptions.cancelText}</button>` : ``}
              ${(this.modalOptions.hasSubmit === true) ? `<button role='button' class='submit' data-target='${this.modalId}'>${(this.modalOptions.submitText === undefined) ? 'OK' : this.modalOptions.submitText}</button>` : ``}
            </footer>
            ` : ``}
          </article>
        </dialog>`;

            $('body').append(this.headHTML + this.mainHTML + this.footerHTML);
            $('body').addClass('no-scroll');

            await this.init();

            // Funktionen für UI-Initialisierung ausführen
            if (typeof this.modalOptions.initFunction !== 'undefined') {
                this.modalOptions.initFunction();
            }
            this._veraportal.initUiStyling(); // Checkboxen Stylingwrapper

            let thisModal = $(`#${this.modalId}`);
            let cancelBtns = thisModal.find('.close');
            let submitBtn = thisModal.find('.submit');

            // Bestätigungsfeld fokussieren und nur Großbuchstaben
            if (this.modalOptions.hasBestaetigung === true) {
                $(`#${this.modalId}-bestaetigung`).trigger('focus');
                $(`#${this.modalId}-bestaetigung`).off('keyup.modal-bestaetigung');
                $(`#${this.modalId}-bestaetigung`).on('keyup.modal-bestaetigung', (evt) => {
                    Utilities.forceKeys($(evt.target)[0] as HTMLInputElement, 'a-zA-Z', true, false);
                });
            }

            //region Cancel-Funktionalität
            //Klick auf den Außenbereich (<dialog>) des Modalfensters (<article>) führt zum Schließen
            $('body').on('click.modal-click-ausserhalb', (evt) => {
                if ($(evt.target).is(`#${this.modalId}`)) {
                    $('body').off('click.modal-click-ausserhalb');
                    cancelBtns.trigger('click');
                }
            });
            cancelBtns.off('click');
            cancelBtns.on('click', () => {
                thisModal.remove();
                $('body').removeClass('no-scroll');
                resolve(false);
            });
            //endregion

            //region Submit-Funktionalität
            submitBtn.off('click');
            submitBtn.on('click', () => {
                if (this.validation() === false) return;
                if (typeof this.modalOptions.validationFunction !== 'undefined') {
                    if (this.modalOptions.validationFunction() === false) return;
                }
                if (this.modalOptions.hasBestaetigung === true && $(`#${this.modalId}-bestaetigung`).val() !== 'OK') {
                    let bestaetigungsWarnungModal = new Modal(this._veraportal);
                    bestaetigungsWarnungModal.show({
                        title: `Bestätigung erforderlich`,
                        body: `Geben Sie im Bestätigungsfeld <i>'OK'</i> ein, um zu bestätigen, dass Sie die Aktion wirklich durchführen möchten.`,
                        hasSubmit: false,
                        hasCancel: true,
                        hasBestaetigung: false,
                        cancelText: 'OK'
                    });
                    return;
                }
                // TODO:low eine Sekunde warten, bevor Modal-DOM ausgehängt wird
                thisModal.hide();
                setTimeout(() => {
                    thisModal.remove();
                    $('body').removeClass('no-scroll');
                }, 1000);
                resolve(true);
            });
            //endregion

        });
    }

    //region überschreibbare Funktionen für Kindklassen
    protected async init() {
        // Modal.init() muss in Kind-Klasse überschrieben werden
    }

    protected validation(): boolean {
        // Modal.validation() muss in Kind-Klasse überschrieben werden
        return true;
    }

    protected antwortHandler(antwortPromise: Promise<any>): Promise<any> {
        // Modal.antwortHandler() kann in Kind-Klasse überschrieben werden
        return antwortPromise;
    }

    //endregion

}